import { Typography, Box } from "@mui/material";

export const Header = () => {
  return (
    <Box>
      <Typography variant="h3" sx={{ mb: 1 }}>
        Create a Lite Rave
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Send a simple recognition to your team
      </Typography>
    </Box>
  );
};
